import * as Sentry from '@sentry/react';
import { SENTRY_DSN_URL } from '../constants';

const sampleRate = import.meta.env.MODE === 'production' ? 0.1 : 1.0;

const client = Sentry.init({
  dsn: SENTRY_DSN_URL,
  release: import.meta.env.VITE_RELEASE_SHA,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.VITE_DEV_ENABLE_SENTRY || !import.meta.env.DEV,
  sendDefaultPii: true,
  tracesSampleRate: sampleRate,
  profilesSampleRate: sampleRate,
  tracePropagationTargets: ['localhost', /^\//, /^https:\/\/.+\.enrichnetwork\.io\/v1/],

  integrations: [
    // Enable HTTP calls tracing
    // https://docs.sentry.io/platforms/javascript/guides/react/performance/
    Sentry.browserTracingIntegration({
      // disable automatic span creation
      instrumentNavigation: false,
      instrumentPageLoad: false,
    }), // Profiling integration requires headers to be set in the server
    // Chrome-only
    // https://docs.sentry.io/platforms/javascript/guides/react/profiling/
    Sentry.browserProfilingIntegration(),
  ],
})!;

console.assert(client, 'Sentry client is not initialized');

// Start the pageload span immediately after initialization
export const initialPageLoadSpan = Sentry.startBrowserTracingPageLoadSpan(client, {
  name: window.location.pathname,
  attributes: {
    [Sentry.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'url',
  },
})!;

console.assert(initialPageLoadSpan, 'Initial page load span is not initialized');
